import Swiper from 'swiper';
import webLogin from '@utils/weblogin';
import TopGiftPage from './TopGiftPage';
export default {
  name: 'TopGifters',
  components: {
    'top-gift-page': TopGiftPage
  },
  methods: {
    opencard: function opencard(uid, source, e) {
      this.$emit('opencard', uid, source, {
        x: e.pageX,
        y: e.pageY - 40
      });
    },
    reload: function reload() {
      this.$refs["topgiftpage".concat(this.selected)].initData(true);
    },
    slideTo: function slideTo(index) {
      if (index === 1 && !webLogin.checkLogin()) {
        this.$emit('authenticate');
        return;
      }
      if (index === 1 && this.$refs.topgiftpage1.list.length === 0) {
        this.$refs.topgiftpage1.initData();
      }
      this.selected = index;
      this.swiper.slideTo(index);
    }
  },
  props: {
    hostid: String,
    videoid: String
  },
  watch: {
    hostid: function hostid(val) {
      this.hostid = val;
    },
    videoid: function videoid(val) {
      this.videoid = val;
    },
    immediate: true,
    deep: true
  },
  data: function data() {
    return {
      swiper: null,
      selected: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    var context = this;
    this.swiper = new Swiper(this.$refs.swiperContainer, {
      on: {
        slideChangeTransitionStart: function slideChangeTransitionStart() {
          if (this.activeIndex === 1) {
            if (!webLogin.checkLogin()) {
              context.$emit('authenticate');
              this.slideTo(0, 0, false);
            }
          }
        }
      }
    });
    this.swiper.on('slideChange', function () {
      return _this.selected = _this.swiper.activeIndex;
    });
  }
};